export default {"src":"/_next/static/media/mnx.1e340ce5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};